import client from '../../utils/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const basePath = '/api/person/:personId/enrollment/'

export const search = createApiAction('person/enrollment/get', client.search(`${basePath}`))

const buildCampusEnrollment = (data, state) => {
  const { campusId, roleIds, ...rest } = data
  const allCampuses = (state.lookup.clients || []).flatMap(item =>
    (item.client?.schools || []).flatMap(school =>
      (school.campuses || []).map(campus => ({
        ...campus,
        district: { id: item.client?.id, type: item.client?.type },
      }))
    )
  )
  const campus = allCampuses.find(c => c.id === campusId) || { id: campusId }
  const roles = state.settings?.role?.search || state.lookup?.roles?.rows || state.lookup?.roles || []
  const campusEnrollmentRoles = (roleIds || []).map(id => ({
    role: roles.find(r => r.id === id) || { id },
  }))
  return { ...rest, campus, campusEnrollmentRoles }
}

export const createCampusEnrollment = createAsyncThunk(
  'person/enrollment/createCampusEnrollment',
  async (payload, { getState }) => {
    const res = await client.create(`${basePath}campus`)(payload)
    return buildCampusEnrollment(res.data, getState())
  },
)

export const updateCampusEnrollment = createAsyncThunk(
  'person/enrollment/updateCampusEnrollment',
  async (payload, { getState }) => {
    const res = await client.save(`${basePath}campus`)(payload)
    const campusId = res.data.campusId ?? payload.campusId
    const roleIds = res.data.roleIds ?? payload.roleIds
    return buildCampusEnrollment({ ...res.data, campusId, roleIds, id: payload.id }, getState())
  },
)

export default function setPersonEnrollmentReducers(builder) {
  builder
    .addCase(search.fulfilled, (state, action) => {
      const personId = action.meta.arg.personId
      if (!state.enrollments) {
        const temp = {}
        temp[personId] = action.payload
        state.enrollments = temp
      } else {
        const enrollments = state.enrollments
        enrollments[personId] = action.payload || []
        state.enrollments = enrollments
      }
    })
    .addCase(createCampusEnrollment.fulfilled, (state, action) => {
      const personId = action.meta.arg.personId
      if (!state.enrollments) state.enrollments = {}
      const personEnrollments = state.enrollments[personId]
      state.enrollments = {
        ...state.enrollments,
        [personId]: {
          schoolEnrollments: personEnrollments?.schoolEnrollments || [],
          campusEnrollments: [...(personEnrollments?.campusEnrollments || []), action.payload],
        },
      }
    })
    .addCase(updateCampusEnrollment.fulfilled, (state, action) => {
      const personId = action.meta.arg.personId
      const personEnrollments = state.enrollments[personId]
      const campusEnrollments = personEnrollments?.campusEnrollments || []
      const index = campusEnrollments.findIndex(item => item.id === action.payload.id)
      if (index !== -1) {
        state.enrollments = {
          ...state.enrollments,
          [personId]: {
            ...personEnrollments,
            campusEnrollments: [
              ...campusEnrollments.slice(0, index),
              action.payload,
              ...campusEnrollments.slice(index + 1),
            ],
          },
        }
      }
    })
  // .addCase(createSchoolEnrollment.fulfilled, (state, action) => {
  //   const employmentId = action.meta.arg.employmentId
  //   const enrollments = state.enrollments
  //   if (enrollments[employmentId]) {
  //     const tempSchoolEnrollment = enrollments[employmentId]?.schoolEnrollments
  //     tempSchoolEnrollment.push(action.payload)
  //     const tempCampusEnrollment = enrollments[employmentId]?.campusEnrollments
  //     enrollments[employmentId] = { schoolEnrollments: tempSchoolEnrollment, campusEnrollments: tempCampusEnrollment }
  //     state.enrollments = enrollments
  //   } else {
  //     enrollments[employmentId] = { schoolEnrollments: [action.payload], campusEnrollments: [] }
  //   }
  // })
  // .addCase(updateSchoolEnrollment.fulfilled, (state, action) => {
  //   const employmentId = action.meta.arg.employmentId
  //   const enrollments = state.enrollments
  //   const tempSchoolEnrollment = enrollments[employmentId]?.schoolEnrollments
  //   let schoolEnrollment = tempSchoolEnrollment.find(item => item.id === action.payload.id)
  //   const schoolEnrollmentIndex = tempSchoolEnrollment.indexOf(schoolEnrollment)
  //   tempSchoolEnrollment[schoolEnrollmentIndex] = action.payload
  //   enrollments[employmentId].schoolEnrollments = tempSchoolEnrollment
  //   state.enrollments = enrollments
  // })
}
